import request from "../../../../..//core/data/network/client/request";
import Api from "../../../../../core/data/network/constants/api_routes";

export default {
  getCompanyEmisores: async (pagination, data) => {
    return request.get(Api.getCompanyEmisores(pagination, data));
  },
  getCompanyEmisoresById: async (id) => {
    return request.get(Api.getCompanyEmisoresById(id));
  },
  createCompanyEmisores: async (data) => {
    return request.post(Api.createCompanyEmisores(), data);
  },
  ActiveInactiveCompanyEmisores: async (id, data) => {
    return request.patch(Api.ActiveInactiveCompanyEmisores(id), data);
  },
  updateCompanyEmisoresById: async (id, data) => {
    return request.put(Api.updateCompanyEmisoresById(id), data);
  },
  updateMassiveCompanyEmisores: async (data) => {
    return request.post(Api.updateMassiveCompanyEmisores(), data);
  },
};